import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import './ButtonIconSquare.less';

const ButtonIconSquare = ({ onClick, className, secondary, iconClassName, role, href, target, rel }) => (
  <Fragment>
    {(role === 'button') && (
      <button onClick={onClick} className={cx('button__icon--square', { secondary }, className)}>
        <i className={cx('zola-ui-icon', iconClassName)} />
      </button>
    )}
    { (role === 'link') && href && (
      <a
        className={cx('button__icon--square', { secondary }, className)}
        href={href}
        target={target}
        rel={rel}
      >
        <i className={cx('zola-ui-icon', iconClassName)} />
      </a>
    )}
  </Fragment>
);

ButtonIconSquare.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
  secondary: PropTypes.bool,
  role: PropTypes.oneOf(['button', 'link']),
  href: PropTypes.string,
  target: PropTypes.string,
  rel: PropTypes.string,
};

ButtonIconSquare.defaultProps = {
  className: '',
  iconClassName: '',
  secondary: false,
  role: 'button',
};

export default ButtonIconSquare;



// WEBPACK FOOTER //
// ./src/components/common/zolaUI/ButtonIconSquare/ButtonIconSquare.jsx